export default "__VITE_ASSET__D6rLCR8T__"